import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { getTranslate } from "react-localize-redux";

import { documentActions, settingActions } from "../../../../redux/actions";
import { getDocumentColumns } from "./allDocumentColumns";

function mapStateToProps(state) {
  const { user, subUser, isSubUser } = state.authentication;
  return {
    translate: getTranslate(state.locale),
    hiddenColumns: state.documents.hiddenColumns,
    columnToShowMenu: state.documents.columnToShowMenu,
    user,
    subUser,
    isSubUser
  };
}

class ColumnToggleMenu extends Component {
  toggleMenu = column => {
    const { dispatch } = this.props;
    dispatch(documentActions.toggleShowColumnMenu(column));
  };
  handleChange = (e, column) => {
    const { user, subUser, isSubUser, dispatch, hiddenColumns } = this.props;
    let currentUser = user;
    if (isSubUser) {
      currentUser = subUser;
    }
    e.stopPropagation();
    e.preventDefault();
    dispatch(documentActions.toggleHiddenColumn(column));
    let _hiddenColumns = (hiddenColumns || []).slice(0);
    var index = _hiddenColumns.indexOf(column);
    if (index >= 0) {
      _hiddenColumns.splice(index, 1);
    } else {
      _hiddenColumns.push(column);
    }
    let gridsSettings = (currentUser.gridsSettings || []).slice(0);
    gridsSettings = gridsSettings.filter(item => item.gridId !== "documents");
    gridsSettings.push({
      gridId: "documents",
      visibleColumns: _hiddenColumns
    });
    dispatch(
      settingActions.changeUserGridsSettings(gridsSettings, currentUser)
    );
  };

  render() {
    const {
      hiddenColumns,
      columnToShowMenu,
      currentColumn,
      isSubUser,
      translate,
      atLeastOneRowHasEBID
    } = this.props;
    let allColumns = getDocumentColumns(translate, isSubUser);
    if (!atLeastOneRowHasEBID) {
      allColumns = allColumns.filter(item => item.key !== "ebid");
    }
    return (
      <Dropdown
        className="trigger"
        isOpen={columnToShowMenu === currentColumn}
        toggle={() => this.toggleMenu(currentColumn)}
      >
        <DropdownToggle
          className="btn btn-default btn-circle"
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <i className="fa fa-angle-down"></i>
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem header>{translate("Columns to display...")}</DropdownItem>
          {allColumns.map((item, index) => (
            <DropdownItem
              header
              key={index}
              className="checkbox-items"
              size="sm"
              data-action="multi-select-action"
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <FormGroup check>
                <Label check onClick={e => this.handleChange(e, item.key)}>
                  <Input
                    type="checkbox"
                    readOnly
                    checked={!(hiddenColumns || []).includes(item.key)}
                  />{" "}
                  {item.text}
                </Label>
              </FormGroup>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

export default connect(mapStateToProps)(ColumnToggleMenu);
